import { requireAuth } from '@/router/helpers';

const FeRoutes = [
  {
    path: '/surveys',
    name: 'SurveyIndexPage',
    component: () => import('./../pages/Index.vue'),
    beforeEnter: requireAuth,
  },
  {
    path: '/survey/*',
    name: 'SurveyViewPage',
    component: () => import('./../pages/View'),
    beforeEnter: requireAuth,
  },
];

const AdminRoutes = [
  {
    path: '/admin/survey/:id/edit/:versionId',
    name: 'AdminSurveyVersionPreview',
    component: () => import('./../pages/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  // forms
  {
    path: '/admin/surveys',
    name: 'AdminSurveyIndexPage',
    component: () => import('./../pages/admin/Index.vue'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/surveys/:tab',
    name: 'AdminSurveyStatusIndexPage',
    component: () => import('./../pages/admin/Index.vue'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/survey/create',
    name: 'AdminSurveyCreatePage',
    component: () => import('./../pages/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/survey/:id/edit',
    name: 'AdminSurveyEditPage',
    component: () => import('./../pages/admin/AddEdit'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: '/admin/survey/:id/view',
    name: 'AdminSurveyEntriesPage',
    component: () => import('./../pages/admin/Entries'),
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
];

export default [...FeRoutes, ...AdminRoutes];
